import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error, or perform any additional actions if needed
    console.error(error, errorInfo);
    // Immediately reload the app
    window.location.reload();
  }

  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;
